import React from 'react'

const IconPromo1 = ({size, className}) => {
    return (
        <svg className={className} width={size} height={size} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M42 12.1947C42 10.9115 43.1943 9.95811 44.4138 10.3574C55.2104 13.8928 63 24.0345 63 35.9999C63 47.9654 55.2104 58.1071 44.4138 61.6425C43.1943 62.0418 42 61.0884 42 59.8052V57.6215C42 56.7366 42.5856 55.966 43.4135 55.6535C51.3494 52.658 57 44.9851 57 35.9999C57 27.0148 51.3494 19.3419 43.4135 16.3463C42.5856 16.0339 42 15.2633 42 14.3784V12.1947ZM9 29C9 27.8954 9.89543 27 11 27H21L32.5858 15.4142C33.8457 14.1543 36 15.0466 36 16.8284V55.1715C36 56.9534 33.8457 57.8457 32.5858 56.5858L21 45H11C9.89543 45 9 44.1045 9 43V29ZM30 45.51V26.49L23.49 33H15V39H23.49L30 45.51ZM49.5 35.9999C49.5 31.8509 47.6318 28.1598 44.6969 25.6851C43.5602 24.7267 42 25.6592 42 27.146V44.8434C42 46.3254 43.5519 47.2588 44.6884 46.3076C47.6282 43.8471 49.5 40.1529 49.5 35.9999Z" fill="#1A8257" />
        </svg>

    )
}

export default IconPromo1
